import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import css from '../Tables.module.css';
import { formater } from './functions';
import ProgressBar from '@ramonak/react-progress-bar';
import edit from '../../../../assets/edit.svg';
import pause from '../../../../assets/pause.svg';

import Button from '../../Button/Button';
import Input from '../../Input/Input';
import { parceBudget, parcePercentage } from '../../../../helpers/parceBudget';

export const BudgetsPerformance = ({
  type,
  el,
  isTotalRow,
  isDefaultCurrentCycleView,
  handleOnMouseEnter,
  handleOnMouseLeave,
  isEditHover,
  handleNameEditClick,
  isEdit,
  isEditOpen,
  error,
  budgetToEdit,
  handleChange,
  handleCloseEdit,
  handleEdit,
  handleClickBudget,
  handleClickClient,
}) => {
  const popupBudgetNameRef = useRef(null);
  const [isOpenBudgetName, setIsOpenBudgetName] = useState(false);
  
  useEffect(() => {
    if (isEdit === false && isEditOpen === null) {
      setIsOpenBudgetName(false);
      return;
    }

    if (isEdit && el.budget_id === isEditOpen) {
      setIsOpenBudgetName(true);
      return;
    }

  }, [isEdit, el.budget_id, isEditOpen]);

  useLayoutEffect(() => {
    const posBottomParent = document.getElementById("dashboardTableBody").getBoundingClientRect().bottom
    if (popupBudgetNameRef.current && posBottomParent && isOpenBudgetName) {
      const posBottomDropdown = popupBudgetNameRef.current.getBoundingClientRect().bottom;
      if (posBottomDropdown - posBottomParent > 40) {
        popupBudgetNameRef.current.style.top = '-18rem';
      }
    }
  }, [isOpenBudgetName]);

  return (
    <tr
      className={`${css.tr} ${isTotalRow ? css.trTotal : ''}`}
      key={formater('key', el, type)}
    >
      <td
        className={css.tdNoWidth}
        style={
          isTotalRow
            ? { color: '#111A39', cursor: 'not-allowed' }
            : { color: '#1649EC', cursor: 'pointer' }
        }
        onMouseEnter={isTotalRow ? null :handleOnMouseEnter.bind(this, el.budget_id)}
        onMouseLeave={isTotalRow ? null : handleOnMouseLeave}
      >
        <span onClick={handleClickBudget}>{isTotalRow ? "Total" : el.budget_name}</span>
        <img
          className={css.edit}
          style={{
            opacity: `${isEditHover === el.budget_id ? 1 : 0}`,
          }}
          alt="edit"
          src={edit}
          onClick={handleNameEditClick.bind(this, el.budget_id)}
        />
        {isOpenBudgetName && (
          <div className={css.editContainer} ref={popupBudgetNameRef}>
            <h2 className={css.editTitle}>Budget Name</h2>
            <Input
              name="name"
              styled="edit"
              value={budgetToEdit?.name || ''}
              onChange={handleChange}
            />
            {error && <p className={css.error}>{error}</p>}
            <div className={css.editBtns}>
              <Button styled="edit" title="Cancel" onClick={handleCloseEdit} />
              <Button styled="edit" title="Save" onClick={handleEdit} />
            </div>
          </div>
        )}
      </td>

      <td
        className={css.tdNoWidth}
        style={{ color: '#1649EC', cursor: 'pointer' }}
        onClick={handleClickClient}
      >
        {el.client_name}
      </td>

      <td className={css.tdNoWidth}>
        {isDefaultCurrentCycleView ? (
          <div className={css.progressBarContainer}>
            <ProgressBar
              completed={+el.spend}
              maxCompleted={+el.budget_amount}
              customLabel={parceBudget(el.spend, el.currency, 0)}
              borderRadius="0"
              height="3rem"
              bgColor={formater('primaryColor', +el.trend, type)}
              baseBgColor={formater('secondaryColor', +el.trend, type)}
              labelAlignment="left"
              labelColor="var(--white)"
              labelSize="1.2rem"
              labelClassName={css.progressBarLabel}
              width="13rem"
            />
            {el?.status === 'paused' && (
              <img className={css.pause} alt="pause" src={pause} />
            )}
          </div>
        ) : (
          <>{parceBudget(el.spend, el.currency, 0)}</>
        )}
      </td>

      <td className={css.tdNoWidth}>{parceBudget(el.conversions, '', 0)}</td>

      <td className={css.tdNoWidth}>{parceBudget(el.cpa, el.currency)}</td>

      <td className={css.tdNoWidth}>{parceBudget(el.revenue, el.currency)}</td>

      <td className={css.tdNoWidth}>{parcePercentage(el.roas)}</td>

      <td className={css.tdNoWidth}>{parceBudget(el.seven_days_cpa, el.currency)}</td>

      <td className={css.tdNoWidth}>{parcePercentage(el.seven_days_roas)}</td>

      <td
        className={`${css.tdNoWidth} ${formater(
          'cpa/roas_change',
          el.seven_days_cpa_change,
        )}`}
      >
        {parcePercentage(el.seven_days_cpa_change)}
      </td>

      <td
        className={`${css.tdNoWidth} ${formater(
          'roas_change',
          el.seven_days_roas_change,
        )}`}
      >
        {parcePercentage(el.seven_days_roas_change)}
      </td>

      <td className={css.tdNoWidth}>{parceBudget(el.forecast_conversions, '', 0)}</td>

      <td className={css.tdNoWidth}>
        {parceBudget(el.forecast_revenue, el.currency)}
      </td>
    </tr>
  );
};
